export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/notes-icon.svg?4dd3c9de2b63bbe42664f7d78570473a";